module.exports = __webpack_public_path__ + "img/weather.a0e7966c.svg";